import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PromotionMailTemplate } from "../../api/sms-api";
import {
  NonPaginatedCRUDState,
  initialNonPaginatedCRUDState,
} from "store/CRUDStore";
import { ErrorWrapper } from "errors/errors";

interface PromotionMailTemplatesState
  extends NonPaginatedCRUDState<PromotionMailTemplate> {
  items: Array<PromotionMailTemplate>;
}

export const initialState: PromotionMailTemplatesState = {
  ...initialNonPaginatedCRUDState,
};

export const slice = createSlice({
  name: "promotionMailTemplates",
  initialState,
  reducers: {
    listPromotionMailTemplatesStart: (state) => {
      state.listLoading = true;
    },
    listPromotionMailTemplatesSuccess: (state, action) => {
      state.items = action.payload;
      state.listLoading = false;
    },
    listPromotionMailTemplatesError: (
      state,
      _action: PayloadAction<ErrorWrapper>
    ) => {
      state.listLoading = false;
    },
    editPromotionMailTemplateStart: (state) => {
      state.editLoading = true;
    },
    editPromotionMailTemplateSuccess: (state) => {
      state.editLoading = false;
    },
    editPromotionMailTemplateError: (
      state,
      _action: PayloadAction<ErrorWrapper>
    ) => {
      state.editLoading = false;
    },
    getPromotionMailTemplateStart: (state) => {
      state.getLoading = true;
    },
    getPromotionMailTemplateSuccess: (
      state,
      action: PayloadAction<PromotionMailTemplate>
    ) => {
      state.item = action.payload;
      state.getLoading = false;
      state.error = undefined;
    },
    getPromotionMailTemplateError: (
      state,
      action: PayloadAction<ErrorWrapper>
    ) => {
      state.getLoading = false;
      state.error = action.payload;
    },
    clearItems: (state) => {
      state.items = [];
    },
  },
});

export const {
  listPromotionMailTemplatesStart,
  listPromotionMailTemplatesSuccess,
  listPromotionMailTemplatesError,
  editPromotionMailTemplateStart,
  editPromotionMailTemplateSuccess,
  editPromotionMailTemplateError,
  getPromotionMailTemplateStart,
  getPromotionMailTemplateSuccess,
  getPromotionMailTemplateError,
  clearItems,
} = slice.actions;

export default slice.reducer;
